import {
  Container,
  DownloadFile,
  Heading3,
  Heading5,
  Icon,
  OrderedList,
  RenderIf,
} from "shared/components";
import { VIEW_MODES } from "shared/contexts/ViewMode";

import styles from "./Content044.module.scss";

export const Content044 = ({ payload }) => {
  const title = payload?.title ?? "";
  const caption = payload?.caption ?? "";
  const list = payload?.list ?? [];
  const { attachmentButtonText, file } = payload?.attachment ?? {};

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <RenderIf viewMode={VIEW_MODES.MOBILE}>
            <Heading3 className={styles.title} color="light">
              {title}
            </Heading3>
          </RenderIf>
          <div className={styles.left}>
            <RenderIf viewMode={VIEW_MODES.DESKTOP}>
              <Heading3 className={styles.title} color="light">
                {title}
              </Heading3>
            </RenderIf>

            <div className={styles.quote}>
              <Icon name="blockquote" className={styles.icon} />
              <Heading5 className={styles.text} color="light">
                {caption}
              </Heading5>
            </div>
            <DownloadFile
              file={file}
              label={attachmentButtonText}
              color="light"
            />
          </div>
          <div className={styles.right}>
            <OrderedList items={list} appearance="bigger" />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content044;
